import { Row, Col, Card } from "react-bootstrap";
import "./city.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useState, useEffect } from "react";
// import { getCity } from "../../api/api";
import { useNavigate } from "react-router-dom";
import { getCity } from "../../redux/api/api";

const City = () => {
  const navigate = useNavigate();
  const [city, setCity] = useState([]);
  const fetchCity = async () => {
    try {
      const res = await getCity();
      if (res.status === 200) {
        setCity(res.data.info);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchCity();
  }, []);
  return (
    <>
      <Row className="pading150" style={{ padding: "0px", margin: "0px" }}>
        <Col sm={12} md={12} lg={12} xl={12} xxl={12} className="city1">
          <span>POPULAR LOCATIONS</span>
        </Col>
        <Col sm={12} md={12} lg={12} xl={12} xxl={12} className="city2">
          <span>Explore the most visited and loved places near you!</span>
        </Col>
      </Row>
      <Row className="city3">
        <Swiper
          className="mySwipercity"
          centeredSlides={true}
          spaceBetween={20}
          slidesPerView={4}
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
          initialSlide={0}
          breakpoints={{
            1440: {
              slidesPerView: 4.5,
              loop: true,
            },

            1024: {
              slidesPerView: 3.5,
              loop: true,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 10,
              loop: true,
            },
            425: {
              slidesPerView: 1.2,
              spaceBetween: 10,
              loop: false,
            },
            375: {
              slidesPerView: 1.2,
              spaceBetween: 10,
              loop: false,
            },
            320: {
              slidesPerView: 1.2,
              spaceBetween: 10,
              loop: false,
            },
            0: {
              slidesPerView: 1.2,
              spaceBetween: 10,
              loop: false,
            },
          }}
        >
          {city.map((item, index) => (
            <SwiperSlide key={item.id}>
              <Card className="citycard">
                <Card.Img variant="top" className="citycardimg" src={item.image} />
                <Card.Body className="citycardbody">
                  <Card.Title className="citycardtitle">{item.name}</Card.Title>
                  <div>
                    <button
                      className="citycardbtn"
                      onClick={() =>
                        navigate(`/event`, {
                          state: { cityId: item._id, stateId: item.stateid },
                        })
                      }
                    >
                      {item.eventCount} Events
                    </button>
                  </div>
                </Card.Body>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </Row>
    </>
  );
};

export default City;
